<template>
	<!--加入共享带宽-->
	<el-dialog 
		:visible.sync="dialogVisible" 
		class="join-share-bandwith-container cps-dialog-icon-line-height"
		:title="$t('eip.text.joinShareBandwidth')" 
		:before-close="doClose"
		:close-on-click-modal="false">
		<div class="i-text">
	        <div class="tip-warning mb20" style="line-height: 20px"
	             v-html="$t('eip.text.joinShareBandwidthTip',[bandwidth])">
	        </div>
      	</div>
		<!--共享带宽列表数据-->
		<el-table :data="shareBandwidthListData" 
			v-loading="refreshLoading" 
			max-height="250">
			<el-table-column min-width="36"  class-name="custom-radio">
				<template slot-scope="scope">
					<span class="radio-label" :class="{checked: scope.row.hasChecked}" @click="chooseShareBandwidth(scope.row)"></span>
				</template>
			</el-table-column>
			<!--名称-->
			<el-table-column :label="$t('subnet.text.name')" min-width="90">
				<template slot-scope="scope">
					<el-tooltip :content="scope.row.name" class="item" effect="dark" >
						<span>{{scope.row.name | maybeEmpty}}</span>
					</el-tooltip>
				</template>
			</el-table-column>
			<!--ID-->
			<el-table-column :label="$t('eip.text.id')" min-width="180">
				<template slot-scope="scope">
					<el-tooltip :content="scope.row.bandwidthPackageId" class="item" effect="dark" >
						<span>{{scope.row.bandwidthPackageId | maybeEmpty}}</span>
					</el-tooltip>
				</template>
			</el-table-column>
			<!--带宽-->
			<el-table-column :label="$t('eip.text.bandwidth')" min-width="100">
				<template slot-scope="scope">
					<span>
						{{scope.row.bandwidth + 'Mbps ' + $t('eip.text.independentBandwidth')}}
					</span>
				</template>
			</el-table-column>
			<!--线路-->
			<el-table-column :label="$t('eip.text.line')" width="90">
				<template slot-scope="scope">
					<span>{{scope.row.lineTypeName | maybeEmpty}}</span>
				</template>
			</el-table-column>
		</el-table>
		<div ref="footer" class="cps-page-footer-simple block jc-container-table-actionBar"
			v-if="total > 0">
			<el-pagination 
				@size-change="handleSizeChange" 
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="pageSizes" 
				:page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="doCancel">{{ $t('detail.text.cancel') }}</el-button>
			<el-button @click="doConfirm" type="primary"
				:disabled="!selectedVpcData.bandwidthPackageId">
				{{ $t('detail.text.sure')}}
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { deepCopy } from '@/common/tool'
export default {
	props: {
		dialogVisible: {
			type: Boolean,
			default: true,
		},
		region: {
			type: String,
			default: ''
		},
		detailData: {
			type: Object,
			default: {}
		}
	},
	data() {
		const initPage = 1;
		return {
			// 表格加载中状态
			refreshLoading: false,
			// 查询到的共享带宽列表数据
			shareBandwidthListData: [],
			// 共享带宽列表总数
			total: 0,
			pageSize: 20,
			pageSizes: [20, 50, 100], // 可选每页展示多少条,
			currentPage: initPage,
			// radio选择的共享带宽数据
			selectedVpcData: {},
		};
	},
	computed: {
		bandwidth(){
			return this.selectedVpcData.chooseBandwidth || '--'
		},
	},
	watch: {
		dialogVisible(newVal) {
			if(newVal) {
				this.getShareBandwidthListData();
			}
		}
	},
	methods: {
		// 关闭弹框
		doClose() {
			this.doReset();
			this.$emit('update:dialog-visible', false);
		},
		// 点击确认按钮，加入共享带宽
		doConfirm() {
			const params = {
				bandwidthPackageId: this.selectedVpcData.bandwidthPackageId,
				elasticIpIds: [this.detailData.elasticIpId],
				region: this.region,
			};
			Ajax.put('/api/cps/addBandwidthPackageIp', params, {				
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(() => {
		        this.$emit('refreshPage');
			}).catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			}).finally(() => {
				this.doClose();
			});
		},
		// 清空表单
		doReset() {
			this.selectedVpcData = {};
		},
		doCancel() {
			this.doClose();
		},
		// 获取共享带宽列表数据
		getShareBandwidthListData() {
			const param = {
				region: this.region,
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
				billingStatus: 'stop',
				lineType: this.detailData.lineType
			};
			this.refreshLoading = true;
			Ajax.get('/api/cps/listBandwidthPackages',param).then((res) => {
				this.refreshLoading = false;
				const list = res.data.bandwidthPackages;
				list.map((item, index) => {
					item.index = index;
					item.hasChecked = false;
				})
				this.shareBandwidthListData = list;
				this.total = res.data.totalCount;
			}).catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
				this.refreshLoading = false;
        	});
		},

		// 切换当前页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getShareBandwidthListData();
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getShareBandwidthListData();
		},

		chooseShareBandwidth(row) {
			let index = row.index;
			let hasChecked = row.hasChecked;
			if (hasChecked) {
				return
			}
			let shareBandwidthList = deepCopy(this.shareBandwidthListData);
			shareBandwidthList.map(item => {
				item.hasChecked = false;
			})
			shareBandwidthList[index].hasChecked = true;
			this.selectedVpcData = {
				bandwidthPackageId: row.bandwidthPackageId,
				chooseBandwidth: (row.bandwidth).toString(),
			}
			this.shareBandwidthListData = shareBandwidthList
		}
	}
};
</script>

<style lang="scss">
	@import '~@/assets/scss/paginationCommon.scss';
	@import 'style';
</style>



// WEBPACK FOOTER //
// src/components/common/joinShareBandwidth/JoinShareBandwidth.vue